import { Star } from 'lucide-react';
import { useState } from 'react';

const StarRating = ({ 
  initialRating = 0, 
  onRatingChange, 
  maxStars = 5, 
  size = 24,
  disabled = false 
}) => {
  const [rating, setRating] = useState(initialRating);
  const [hoverRating, setHoverRating] = useState(0);
  
  const handleClick = (starValue) => {
    if (disabled) return;
    setRating(starValue);
    onRatingChange && onRatingChange(starValue);
  };
  
  const handleMouseEnter = (starValue) => {
    if (disabled) return;
    setHoverRating(starValue);
  };
  
  const handleMouseLeave = () => {
    if (disabled) return;
    setHoverRating(0);
  };

  const stars: JSX.Element[] = [];

  for (let i = 1; i <= maxStars; i++) {
    const isFilled = i <= (hoverRating || rating);
    
    stars.push(
      <button
        key={i}
        type="button"
        className="star-rating-button"
        onClick={() => handleClick(i)}
        onMouseEnter={() => handleMouseEnter(i)}
        onMouseLeave={handleMouseLeave}
        disabled={disabled}
        aria-label={`Rate ${i} out of ${maxStars} stars`}
      >
        <Star 
          size={size}
          className={`star-rating${isFilled ? ' filled-star-rating' : ''}`}
        />
      </button>
    );
  }
  
  return (
    <div className="flex items-center gap-1">
      <div className="flex">
        {stars}
      </div>
    </div>
  );
};

  export default StarRating;